export default __webpack_public_path__ + "static/media/logo.7cbb91e4.png";